import React, { useCallback, useEffect, useState } from 'react'
import Toast from 'react-bootstrap/Toast'
import ToastHeader from 'react-bootstrap/ToastHeader'
import ToastBody from 'react-bootstrap/ToastBody'
import styled from 'styled-components'
import { NotificationProps } from './types'

const Container = styled.div`
    z-index: 9500;
    position: absolute;
    top: 10px;
    display: flex;
    justify-content: center;
    width: 70%;
    left: 15%;
    padding: 10px;
`

const ErrorToastHeader = styled(ToastHeader)`
    background-color: #dc3545;
    color: black;
    border-bottom-color: #842029;
    justify-content: space-between;
`

const ErrorToastBody = styled(ToastBody)`
    background-color: #bb2d3b;
    color: black;
`

const WarningToastHeader = styled(ToastHeader)`
    background-color: #ffca2c;
    color: black;
    border-bottom-color: #f1a12c;
    justify-content: space-between;
`

const WarningToastBody = styled(ToastBody)`
    background-color: #ffc107;
    color: black;
`

const InfoToastHeader = styled(ToastHeader)`
    justify-content: space-between;
`

const Notification = (props: NotificationProps) => {
    const { header, message, isVisible, type, onDismiss } = props
    const [isShow, setIsShow] = useState<boolean>(isVisible)

    const onHideNotification = useCallback(() => {
        onDismiss ? onDismiss() : setIsShow(false)
    }, [onDismiss, setIsShow])

    useEffect(() => {
        if (isShow && type !== 'error') {
            window.setTimeout(() => onHideNotification(), 2000)
        }
    }, [isShow])

    useEffect(() => {
        setIsShow(isVisible)
    }, [isVisible])

    if (!isShow) return null

    return (
        <Container>
            <Toast show={isShow} onClose={onHideNotification}>
                {type === 'error' && (
                    <ErrorToastHeader>{header}</ErrorToastHeader>
                )}
                {type === 'warning' && (
                    <WarningToastHeader>{header}</WarningToastHeader>
                )}
                {type === 'info' && <InfoToastHeader>{header}</InfoToastHeader>}
                {type === 'error' && <ErrorToastBody>{message}</ErrorToastBody>}
                {type === 'warning' && (
                    <WarningToastBody>{message}</WarningToastBody>
                )}
                {type === 'info' && <ToastBody>{message}</ToastBody>}
            </Toast>
        </Container>
    )
}

export default Notification
